import {ReactNode} from 'react'

import {BUTTON_BOX_SIZE, BUTTON_VARIANT, ButtonBox, CloseButton, HeaderBrandWindow} from '@defign/ui'
import classNames from 'classnames/bind'

import {isMobileDisplay} from '@web/helpers/userAgent'

import {FlexibleBox} from '../lib/FlexibleBox'

import styles from './GeneralErrorTemplate.module.scss'

const cx = classNames.bind(styles)

export interface GeneralErrorTemplateProps {
    headerText?: string
    mainText: ReactNode
    subText: ReactNode
    buttonText: ReactNode
    onClickButton: () => void
    isAlignCenter?: boolean
    shouldRenderHeader?: boolean
    headerComponent?: ReactNode
}

const DefaultHeader = ({headerText}: {headerText?: string}) => (
    <HeaderBrandWindow rightComponent={isMobileDisplay && <CloseButton />} title={headerText} isPayApp />
)

export function GeneralErrorTemplate({
    headerText,
    mainText,
    subText,
    buttonText,
    onClickButton,
    isAlignCenter = false,
    shouldRenderHeader = false,
    headerComponent = <DefaultHeader headerText={headerText} />,
}: GeneralErrorTemplateProps) {
    return (
        <FlexibleBox
            isFullHeight
            backGroundGrayLevel="WHITE"
            contentColorType="white"
            topElement={shouldRenderHeader ? headerComponent : null}
        >
            <div className={cx('article', {'align-center': isAlignCenter})}>
                {!shouldRenderHeader && <h1 className="blind">네이버페이</h1>}
                <strong className={cx('title')}>{mainText}</strong>
                <p className={cx('text')}>{subText}</p>
                <div className={cx('area-button')}>
                    <ButtonBox
                        text={buttonText}
                        size={BUTTON_BOX_SIZE.MEDIUM}
                        variant={BUTTON_VARIANT.TERTIARY}
                        onClick={onClickButton}
                    />
                </div>
            </div>
        </FlexibleBox>
    )
}

export default GeneralErrorTemplate
